import { render, staticRenderFns } from "./remind.vue?vue&type=template&id=44eb6d39&scoped=true"
import script from "./remind.vue?vue&type=script&lang=js"
export * from "./remind.vue?vue&type=script&lang=js"
import style0 from "./remind.vue?vue&type=style&index=0&id=44eb6d39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44eb6d39",
  null
  
)

export default component.exports